import React from 'react';
import { Form, Radio } from 'antd';
export const RadioButton = ({ name, label, valueName, labelName, list }) => {
  return (
    <Form.Item name={name} label={label}>
      <Radio.Group>
        {list.map(value => {
          return (
            <Radio value={valueName ? value[valueName] : value}>
              {labelName ? value[labelName] : value}
            </Radio>
          );
        })}
      </Radio.Group>
    </Form.Item>
  );
};

export default RadioButton;
